<template>
  <div class="section" style="min-width: 1200px;">
    <div class="form-card-wrapper" style="width: 100%;">
      <div class="section form-row">
        <span class="title">{{ $t('SeaExport.DoorToDoorLoading') }} <span style="color: red; font-weight:lighter;margin:30px;">{{ $t('SeaExport.SaveBusinessBeforeEnterMultiGate') }}<!--{{$t('Message.MultiDoorsTip')}}--></span></span>
        <div style="display:flex;flex-direction:column">
          <div v-if="showSecondSync">
            <el-button type="primary" @click="syncToDischargingTruckingInfo">{{ $t('SeaExport.SecondarySynchronization') }}</el-button>
          </div>
          <div v-show="job.multiplePickups">
            <cargo-ag-grid
              no="1"
              :grid-options="top.gridOptions"
              :grid-params.sync="top.gridParams"
              :column-defs="top.columnDefs"
              :row-data="trucking"
              style="width:100%;"
              @gridReady="params=>{topgridApi=params.api}"
            />
          </div>
          <div v-if="job.multiplePickups" class="app-main-inner-row operations" style="padding:5px 0">
            <div v-show="cooperateEdit" class="triggers">
              <div>
                <el-button no="2" type="primary" :disabled="readonly" @click="copyNewHandler">{{ $t('SeaExport.copyAndAddPoItems')
                }}
                </el-button>
                <el-button no="3" type="primary" :disabled="readonly" @click="addHandler">{{ $t('SeaExport.Add2') }}</el-button>
                <el-button no="4" :disabled="!btnEnable.btDel " type="danger" @click="delHandler">{{ $t('SeaExport.Delete') }}
                </el-button>
              </div>
            </div>
          </div>
          <el-divider v-if="job.multiplePickups" />
          <el-form :inline="true" class="inline-form" label-width="100px" label-position="left">
            <el-form-item :disabled="readonly">
              <template slot="label">
                <el-checkbox v-model="job.multiplePickups" no="5" @change="multiPickupsChangeHandler">{{
                  $t('SeaExport.MultiDoors') }}
                </el-checkbox>
              </template>
              <el-checkbox v-model="truckingInfo.loadingPortService" no="loadingPortService" :disabled="readonly" style="width: auto;" @change="onLoadingPortServiceChange">
                {{ $t('CargoMsg.Cargo_PortOfLoading') }}{{ isZh ? '' : ' ' }}{{ $t('SeaExport.Service') }}
              </el-checkbox>
              <el-checkbox v-model="truckingInfo.dischargingPortService" no="dischargingPortService" :disabled="readonly" style="width: auto;" @change="onDischargingPortServiceChange">
                {{ $t('CargoMsg.Cargo_PortOfDischarge') }}{{ isZh ? '' : ' ' }}{{ $t('SeaExport.Service') }}
              </el-checkbox>
            </el-form-item>
          </el-form>
          <el-form :inline="true" class="inline-form" label-width="100px" label-position="left">
            <el-form-item :disabled="readonly">
              <label>{{ $t('SeaExport.Quantity') }}</label>
              <el-input-number
                no="6"
                :value="truckingInfo.quantity||undefined"
                :disabled="readonly"
                :min="0"
                :max="99999"
                :precision="0"
                controls-position="right"
                style="width: 119px;margin-left: 2px"
                @input="val=>{truckingInfo.quantity=val}"
              />
              <label>{{ $t('SeaExport.Weight') }}</label>
              <el-input-number
                no="7"
                :value="truckingInfo.weight||undefined"
                :disabled="readonly"
                :min="0"
                :max="99999"
                :precision="3"
                controls-position="right"
                style="width: 119px"
                @input="val=>{truckingInfo.weight=val}"
              />
              <label>{{ $t('SeaExport.Cubage') }}</label>
              <el-input-number
                no="8"
                :value="truckingInfo.cubage||undefined"
                :disabled="readonly"
                :min="0"
                :max="99999"
                :precision="3"
                controls-position="right"
                style="width: 119px"
                @input="val=>{truckingInfo.cubage=val}"
              />
            </el-form-item>
            <el-form-item v-if="job.multiplePickups" label="S/O No." :label-width="isZh ? '' : '120px'" class="custom">
              <so-no-selector v-model="truckingInfo.soNo" no="9" :so-no="soNo" :disabled="readonly" style="width:400px" />
            </el-form-item>
          </el-form>
          <div class="trucking-form">
            <el-form :disabled="readonly" :label-width="isZh ? '100px' : '145px'" label-position="left">
              <el-form-item :label="$t('SeaExport.HaulageCompany')">
                <cargo-company-select
                  no="10"
                  :disabled="readonly"
                  :method-params="{truckCmp:true,active:true}"
                  :default-value="truckingInfo.carryingCmp||''"
                  style="width:400px; display:inline-block"
                  @change="p=>{truckingInfo.carryingCmp=p.value||0;carryingCmpChangeHandler()}"
                />
              </el-form-item>

              <el-form-item :label="$t('SeaExport.HaulageContactPerson')" class="custom">
                <el-select
                  v-model="truckingInfo.driver"
                  no="11"
                  style="width:400px"
                  :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                  allow-create
                  default-first-option
                  clearable
                  filterable
                  @change="carryingContactsChangeHandler"
                >
                  <el-option
                    v-for="(item,index) in carryingContacts"
                    :key="index"
                    :label="item.contactPerson"
                    :value="item.contactPerson"
                  />
                </el-select>
              </el-form-item>

              <el-form-item class="custom" :label="truckingInfo.loadingPortService?$t('SeaExport.CargosExpectedArrivalDatePacking'):$t('CargoMsg.EstimatedDeliveryDate')">
                <el-date-picker
                  v-model="truckingInfo.loadingDate"
                  no="12"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  placeholder=" "
                  style="width:400px"
                />
              </el-form-item>

              <el-form-item :label="$t('Warehouse.Driver')" :disabled="txtEditEable" class="custom">
                <el-select
                  v-model="truckingInfo.driverName"
                  style="width:400px"
                  no="12"
                  :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                  :allow-create="true"
                  :clearable="true"
                  filterable
                  @change="driverInfomationsChangeHandler"
                >
                  <el-option
                    v-for="(item,index) in driverInfomations"
                    :key="index"
                    :label="item.driverName"
                    :value="item.driverName"
                  />
                </el-select>
              </el-form-item>

              <el-form-item class="custom" :label="$t('SeaExport.travelTime')">
                <el-input-number
                  v-model="truckingInfo.travelHour"
                  no="13"
                  :min="0"
                  controls-position="right"
                  style="width:105px"
                />
                <span style="margin:10px">{{ $t('SeaExport.Hour') }}</span>
                <el-input-number
                  v-model="truckingInfo.travelMinute"
                  no="14"
                  :min="0"
                  controls-position="right"
                  style="width:100px"
                />
                <span>{{ $t('SeaExport.Minute') }}</span>
              </el-form-item>

              <el-form-item :label="$t('SeaExport.DoorContactPerson')" class="custom">
                <el-input v-model="truckingInfo.doorMan" no="15" style="width:400px" />
              </el-form-item>

              <el-form-item :label="$t('SeaExport.DoorAddress')" class="custom">
                <el-input v-model="truckingInfo.doorAddr" no="16" type="textarea" :rows="3" :filter-chars="false" style="width:400px" @change="refreshGrid" />
              </el-form-item>

              <el-form-item :label="$t('SeaExport.ZIP')" class="custom">
                <el-input v-model="truckingInfo.zipCode" no="zipCode" style="width:400px" />
              </el-form-item>
              <el-form-item class="auto-width" label-width="0">
                <div style="display: flex;">
                  <el-form-item class="custom" :label="$t('Pricing.BelongingCity')">
                    <cargo-advance-select
                      no="17"
                      style="width:160px"
                      :disabled="readonly"
                      :tag-name="$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      :cache="false"
                      filterable
                      :default-value="truckingInfo.cityCode"
                      :static-options="cityList"
                      :placeholder="$t('SeaExport.PleaseSelect')"
                      @parentCallBack="p=>truckingInfo.cityCode=p.value"
                    />
                  </el-form-item>
                  <el-form label-width="100px" label-position="left">
                    <el-form-item class="custom" :label="$t('Warehouse.PalletSum')">
                      <el-input-number no="18" style="width:140px;" :value="truckingInfo.palletSum" :disabled="readonly" :min="0" :max="999999999999" :precision="0" :controls="false" @input="val=>{truckingInfo.palletSum=val || 0}" />
                    </el-form-item>
                  </el-form>
                </div>
              </el-form-item>

              <el-form-item label="PO">
                <el-input v-model="truckingInfo.po" no="po" :disabled="readonly" :filter-chars="false" type="textarea" :rows="3" style="width:400px" />
              </el-form-item>
            </el-form>

            <el-form :label-width="isZh ? '100px' : '120px'" label-position="left">
              <el-form-item class="custom" :label="$t('SeaExport.HaulageNo')">
                <el-input
                  v-model="truckingInfo.truckOrderNo"
                  no="19"
                  :disabled="readonly"
                  :style="{width: isZh ? '160px' : '155px'}"
                  @change="refreshGrid"
                />
                <label :style="{margin: isZh ? '' : '0 1px'}">{{ $t('SeaExport.HaulageCharge') }}</label>
                <el-input-number
                  v-model="truckingInfo.truckingFee"
                  no="20"
                  :disabled="readonly"
                  :min="0"
                  :max="999999999999"
                  :precision="2"
                  controls-position="right"
                  style="width:120px"
                  @change="truckingFeeCharge"
                />
                <span class="currency">{{ localCurrency }}</span>
              </el-form-item>

              <el-form-item class="custom" :label="$t('SeaExport.Tel')">
                <el-input v-model="truckingInfo.driverTel" no="21" :disabled="readonly" style="width:400px" />
              </el-form-item>

              <el-form-item class="custom" :label="truckingInfo.loadingPortService?$t('SeaExport.CargoActArrivalDatePacking'):$t('CargoMsg.ActualDeliveryDate')">
                <el-date-picker
                  v-model="truckingInfo.actLoadingDate"
                  no="actLoadingDate"
                  :disabled="readonly"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width:400px"
                />
              </el-form-item>

              <el-form-item :label="$t('SeaExport.PlateNumber')" class="custom">
                <el-input
                  v-if="isEdit"
                  v-model="truckingInfo.plateNumber"
                  no="22"
                  :disabled="readonly"
                  :style="{width:isZh?'280px':'215px'}"
                />
                <span v-if="readonly" class="plate_number" :style="{width:isZh?'280px':'215px'}">{{ truckingInfo.plateNumber }}</span>
              </el-form-item>

              <el-form-item :label="$t('Warehouse.DriverPhone')" :disabled="txtEditEable" class="custom">
                <el-input
                  v-model="truckingInfo.driverPhone"
                  no="45"
                  :disabled="readonly"
                  style="width:400px;"
                />
              </el-form-item>

              <el-form-item :label="$t('SeaExport.Door')" class="custom">
                <cargo-repeat-value-select
                  v-model="truckingInfo.doorName"
                  no="24"
                  :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                  filterable
                  :allow-create="true"
                  clearable
                  :options="doorList"
                  label-field="name"
                  value-field="name"
                  unique-field="uuid"
                  :disabled="readonly"
                  :match-of-repeat-value="matchOfRepeatDoor"
                  style="width: 400px"
                  @change="doorsChangeHandler"
                />
                <el-button v-show="$checkPermission(['button_Common_AddSite'])" no="addDoor" :disabled="!isEdit" class="vehicle-btn" type="primary" size="mini" @click="addDoor">{{ $t('Partners.doorInformation') }}</el-button>
              </el-form-item>

              <el-form-item class="custom" :label="$t('SeaExport.Tel')">
                <el-input v-model="truckingInfo.doorManTel" no="25" :disabled="readonly" style="width:400px" />
              </el-form-item>

              <el-form-item :label="$t('SeaExport.AdditionalNotes')">
                <el-input v-model="truckingInfo.remarks" no="26" :disabled="readonly" :filter-chars="false" type="textarea" :rows="3" style="width:400px" @change="refreshGrid" />
              </el-form-item>

              <el-form-item v-if="truckingInfo.dischargingPortService" :label="$t('CargoMsg.DischargingWay')">
                <el-select
                  :value="truckingInfo.dischargingWay?truckingInfo.dischargingWay.split(','):[]"
                  no="dischargingWay"
                  :disabled="readonly"
                  multiple
                  style="width:400px"
                  @input="value=>{truckingInfo.dischargingWay=value.join(',')}"
                >
                  <el-option value="DROP" />
                  <el-option value="LIVE UNLOAD" />
                  <el-option value="EXCHANGE PALLETS" />
                  <el-option v-if="job.lob==='SI'" value="拼车" />
                  <el-option v-if="job.lob==='SI'" value="整车" />
                  <el-option v-if="job.lob==='SI'" value="快递" />
                  <el-option v-if="job.lob==='SI'" value="空运" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="truckingInfo.dischargingPortService" :label="$t('CargoMsg.LatestDeliveryDate')">
                <el-date-picker
                  v-model="truckingInfo.actDeliveryDate"
                  no="actDeliveryDate"
                  :disabled="readonly"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width:400px"
                />
              </el-form-item>
              <el-form-item class="custom" :label="$t('Partners.IdentityCard')">
                <el-input v-model="truckingInfo.driverIdCard" no="60" :disabled="readonly" style="width:400px" />
              </el-form-item>
            </el-form>
          </div>

          <div v-if="job.lob==='SE' || job.lob==='SI' || job.lob==='RE' || job.lob==='RI'" class="app-main-inner-row operations" style="margin-bottom: 5px;padding-left: 0;">
            <div v-show="cooperateEdit" class="triggers">
              <div>
                <el-button no="27" type="primary" :disabled="!btnEnable.grpTruckOrderBtns" @click="linkUsageClickHandler">{{ $t('SeaExport.AddPackingInfo') }}
                </el-button>
                <el-button no="28" type="danger" :disabled="!btnEnable.grpTruckOrderBtns" @click="delLinkUsageClickHandler">{{ $t('SeaExport.RemovePackingInfo') }}
                </el-button>
                <!--为 编辑状态 el-dropdown 按钮 不可用 新增的按钮-->
                <el-button v-if="!btnEnable.grpTruckOrderBtns" no="29" type="primary" :disabled="!btnEnable.grpTruckOrderBtns">{{ command1 }}
                </el-button>
                <el-dropdown
                  v-if="btnEnable.grpTruckOrderBtns"
                  no="30"
                  split-button
                  type="primary"
                  :disabled="!btnEnable.grpTruckOrderBtns"
                  style="margin-left: 5px;"
                  @click="btnConnectedTruckClickHandler()"
                  @command="p=>{command1=p;btnConnectedTruckClickHandler()}"
                >
                  {{ command1 }}
                  <el-dropdown-menu slot="dropdown" :disabled="!btnEnable.grpTruckOrderBtns">
                    <el-dropdown-item :disabled="!btnEnable.grpTruckOrderBtns" :command="$t('SeaExport.DispatchTuckOrder')">{{ $t('SeaExport.DispatchTuckOrder') }}
                    </el-dropdown-item>
                    <el-dropdown-item :disabled="!btnEnable.grpTruckOrderBtns" :command="$t('SeaExport.ModifyTuckOrder')">{{ $t('SeaExport.ModifyTuckOrder') }}
                    </el-dropdown-item>
                    <el-dropdown-item :disabled="!btnEnable.grpTruckOrderBtns" :command="$t('SeaExport.RevokeTuckOrder')">{{ $t('SeaExport.RevokeTuckOrder') }}
                    </el-dropdown-item>
                    <el-dropdown-item :disabled="!btnEnable.grpTruckOrderBtns" :command="$t('SeaExport.SearchTuckOrder')">{{ $t('SeaExport.SearchTuckOrder') }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button :disabled="!btnEnable.grpTruckOrderBtns" type="primary" @click="showTuckOrderLogClickHandler">{{ $t('SeaExport.ShowTuckOrderLog') }}
                </el-button>
              </div>
            </div>
          </div>
          <div v-if="job.lob==='SE' || job.lob==='SI' || job.lob==='RE' || job.lob==='RI'" style="flex-grow:1;">
            <cargo-ag-grid
              v-if="gridVisible.dgUsage"
              config-module="130005"
              no="31"
              :grid-options="gridOptions"
              :grid-params.sync="gridParams"
              :column-defs="columnDefs"
              :row-data="usages"
              style="width:100%;height:350px"
              @gridReady="params=>gridApi=params.api"
            />
            <cargo-ag-grid
              v-if="gridVisible.dgUsageG7"
              config-module="130006"
              no="32"
              :grid-options="gridOptions"
              :grid-params.sync="gridParams"
              :column-defs="columnDefsG7"
              :row-data="usages"
              style="width:100%;height:350px"
              @gridReady="params=>gridApi=params.api"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 选择装箱信息弹窗 -->
    <trucking-container-usage-link-dialog
      :visible.sync="containerUsageDialog.visible"
      :job-uuid="job.uuid"
      :trucking-info-uuid="truckingInfo.uuid"
      @selectContainerUsageHandler="selectContainerUsageHandler"
    />

    <!-- 日志弹出窗 -->
    <tuck-order-log-dialog
      :visible.sync="truckOrderLogDialog.visible"
      :row-data="truckOrderLogDialog.rowData"
    />
    <!-- 日志弹出窗 -->
    <error-log-dialog
      :visible.sync="errorLogDialog.visible"
      :row-data="errorLogDialog.rowData"
    />

    <!-- 附件 -->
    <upload-common-file
      :visible.sync="uploadCommonFileDialog.visible"
      :model="uploadCommonFileDialog.model"
    />
    <yazuishou-dialog
      :visible="yazuishouVisible"
      @submit="submitCallBack"
    />

    <!-- 门点信息公共弹窗 -->
    <door-point-information
      :v-if="addDoorDialog.visible"
      :visible.sync="addDoorDialog.visible"
      :action="action"
      :site="addDoorDialog.form"
      @loadSites="loadSites"
    />

  </div>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import YazuishouDialog from '@/components/Cargo/Job/YazuishouDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

import { DateAutoInitRuleManage } from '@/class/cargo/model/utils/DateAutoInitRuleManage'
import { Job } from '@/class/model/booking/Job'
import StrUtils from '@/utils/StrUtils'
import { Trucking } from '@/class/model/booking/Trucking'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { delContaierUsageLinkedTruckingInfo, queryByTruckingInfo } from '@/api/seaExport/containerUsage'
import { Company } from '@/class/model/mdm/Company'
import { addSites, getSites } from '@/api/company'
import ColumnUtils from '@/utils/ColumnUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import SoNoSelector from '@/components/Cargo/Job/soNoSelector'
import { TabError } from '@/utils/class/TabError'
import { Charge } from '@/class/model/act/Charge'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import TruckingContainerUsageLinkDialog from '@/components/Cargo/Job/truckingContainerUsageLinkDialog'
import TuckOrderLogDialog from '@/components/Cargo/Job/tuckOrderLogDialog'
import ErrorLogDialog from '@/components/Cargo/Job/errorLogDialog'
import UploadCommonFile from '@/components/Cargo/Job/uploadCommonFile'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { sendTruckOrder, sendTruckOrder2Duck, sendModifiedTruckOrder, revokeTruckOrder, getTruckOrder, queryTuckOrderLog, queryEventLogList, syncTruckingToDischargingTruckingInfo } from '@/api/seaExport/trucking'
import { DocumentManage } from '@/utils/commonUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import CargoDateTimeFieldInput from '@/components/Cargo/Common/cargoDateTimeFieldInput'
import cargoRepeatValueSelect from '@/components/Cargo/Common/cargoRepeatValueSelect'
import { updateTrackingForDocumentType } from '@/api/fileHistory'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import moment from 'moment'
import { getLocationList } from '@/api/location'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import { getSettlementAgentsByCmpIdx, getSettlementAgentsByCmpIdxList } from '@/api/company'
import AddDoorDialog from '@/views/cargo/v0/SeaExport/components/booking/addDoorDialog.vue'
import DoorPointInformation from '@/views/cargo/v0/Information/components/partner/tab/doorPointInformation.vue'

export default {
  name: 'TabTrucking',
  components: {
    DoorPointInformation,
    AddDoorDialog,
    CargoDateTimeFieldInput, UploadCommonFile, ErrorLogDialog, TruckingContainerUsageLinkDialog, TuckOrderLogDialog, SoNoSelector, cargoAdvanceSelect, cargoCompanySelect, YazuishouDialog,
    cargoRepeatValueSelect
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentViewCacheData: {
        customerSettlementAgentMap: new Map() // 结算对象关联的结算代理
      },
      isZh: this.$store.getters.language === 'zh',
      addDoorDialog: {
        visible: false,
        form: {
          title: '',
          name: '',
          contact: '',
          phone: '',
          address: '',
          remarks: '',
          city: '',
          companyUuid: ''
        }
      },
      loading: null,
      selectTypeNames: TYPE_NAMES,
      topgridApi: null,
      top: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            this.onCellFocused(event)
          },
          onRowClicked: this.selectionChangeHandler
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.HaulageCompany'),
            field: 'carryingCmp',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            },
            lockVisible: true
          },
          {
            headerName: this.$t('SeaExport.HaulageNo'),
            field: 'truckOrderNo',
            width: 150
          },
          {
            headerName: this.$t('SeaExport.Door'),
            field: 'doorName',
            width: 150
          },
          {
            headerName: this.$t('SeaExport.ContactPerson'),
            field: 'driver',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.Tel'),
            field: 'driverTel',
            width: 120
          },
          {
            headerName: this.$t('SeaExport.AdditionalNotes'),
            field: 'remarks',
            hide: true,
            width: 120
          },
          {
            headerName: this.$t('SeaExport.DoorAddress'),
            field: 'doorAddr',
            hide: true,
            width: 120
          }
        ]
      },
      command1: this.$t('SeaExport.DispatchTuckOrder'),
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'eqSize')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'eqType')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerNo')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerWeight')
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'sealNo')
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 110,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.HaulageCharge'),
          field: 'truckingFee',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'el-input-number',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.AuditMoney'),
          field: 'auditMoney',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.TuckStatus'),
          field: 'truckStatus',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.truckingOrderLableFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.TuckStatusDescription'),
          field: 'description',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.truckingPlaceDep'),
          field: 'truckingPlaceOfDep',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.truckingPlaceDest'),
          field: 'truckingPlaceOfDest',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UploadAttachment'),
          field: 'uuid',
          width: 120,
          cellRenderer: params => {
            const uploadFileClickHandler = this.documentManage.getPath('uploadFileClickHandler')
            return `<a onclick="${uploadFileClickHandler}('${params.value}')" style="color:#46a6ff">${this.$t('CargoMsg.Cargo_Attachment')}</a>`
          }
        },
        {
          headerName: this.$t('SeaExport.AuditState'),
          field: 'auditState',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.costStatusLableFun(params.data, 'auditState')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ConfirmExpenses'),
          field: 'auditUrl',
          width: 120,
          cellRenderer: params => {
            if (params.data.auditUrl && !params.data.auditState) {
              const auditUrlClickHandler = this.documentManage.getPath('auditUrlClickHandler')
              return `<a onclick="${auditUrlClickHandler}('${params.value}')" style="color:#46a6ff">${this.$t('CargoMsg.Cargo_ConfirmExpenses')}</a>`
            } else return ''
          }
        },
        {
          headerName: this.$t('SeaExport.HLID'),
          field: 'dcSequence',
          width: 120,
          cellRenderer: (params) => {
            if (!StrUtils.isEmpty(params.data.dcTicketNo) && !StrUtils.isEmpty(params.data.dcSequence)) {
              return params.data.dcTicketNo + '_' + params.data.dcSequence
            } else {
              return params.data.dcSequence
            }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerNoDiff'),
          field: 'containerNoDiff',
          width: 120,
          headerClass: 'diffTipColumn'
        },
        {
          headerName: this.$t('SeaExport.DriverNameHL'),
          field: 'driverNameHL',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.DriverPhoneHL'),
          field: 'driverPhoneHL',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.TruckNoHL'),
          field: 'truckNoHL',
          width: 120
        },
        // {
        //   headerName: this.$t('SeaExport.dcTicketNo'),
        //   field: 'dcTicketNo',
        //   width: 120,
        //   hide: true
        // },
        // {
        //   headerName: this.$t('SeaExport.dcSequence'),
        //   field: 'dcSequence',
        //   width: 120,
        //   hide: true
        // },
        {
          headerName: this.$t('SeaExport.ContainerSerialNo'),
          field: 'serialNo',
          width: 120
        }
      ],
      columnDefsG7: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          field: 'serialNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerNo')
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'sealNo')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerWeight')
          }
        },
        {
          headerName: this.$t('SeaExport.PlateNumber'),
          field: 'tosCarNum',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PlannedDepartureTime'),
          field: 'tosStartTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ActualDepartureTime'),
          field: 'tosGstartTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.PlannedArrivalTimeAtTheFactory'),
          field: 'tosInTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.RealTimeOfArrivalAtTheFactory'),
          field: 'tosGinTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.PlannedTimeToLeaveTheFactory'),
          field: 'tosOutTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ActualTimeToLeaveTheFactory'),
          field: 'tosGoutTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.PlannedArrivalTime'),
          field: 'tosEndTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ActualArrivalTime'),
          field: 'tosGarriveTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.currentLocation'),
          field: 'tosLocation',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.ViewExceptions'),
          field: 'tosTaskId',
          width: 120,
          cellRenderer: params => {
            const showErrorLogClickHandler = this.documentManage.getPath('showErrorLogClickHandler')
            return `<a onclick="${showErrorLogClickHandler}('${params.value}')" style="color:#46a6ff">查看异常</a>`
          }
        }
      ],
      rowData: [],
      gridApi: null,
      gridParams: {},
      currentUser: {},
      job: new Job().fillDefaultValue().getData(),
      multiPickups: false,
      trucking: [],
      cityList: [],
      truckingInfo: new Trucking().fillDefaultValue().getData(), // 初始化
      soNo: '',
      btnEnable: {
        btDel: false,
        grpTruckOrderBtn: false
      },
      gridVisible: {
        dgUsage: false,
        dgUsageG7: false
      },
      usages: [],
      isAllowGridClick: false, // 是否允许触发门点grid的点击事件
      needReloadDriver: false, // 切换公司时, 重新读取司机信息, 否则不读取
      neednotReloadTelephone: false, // 表格内切换门点时, 不按照联系人名称重新读取电话
      txtEditEable: false, // 编辑文本框是否允许编辑
      needSaveCustomer: false, // 是否需要更新job.customer
      txtTMSHint: '',
      carryingContacts: [],
      driverInfomations: [],
      doorList: [],
      matchOfRepeatDoor: options => {
        const option = options.find(p => p.contact === this.truckingInfo.doorMan)
        return option || options[0]
      },
      delTruckingInfoUuids: [], // 记录删除的uuid
      containerUsageDialog: {
        visible: false
      },
      truckOrderLogDialog: {
        visible: false,
        rowData: []
      },
      errorLogDialog: {
        visible: false,
        rowData: []
      },
      uploadCommonFileDialog: {
        visible: false,
        model: {}
      },
      documentManage: new DocumentManage(),
      containerUsages: [], // 记录装箱明细 修改的拖车费
      yazuishouVisible: false,
      oldTruckintFee: 0
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    showSecondSync() {
      if (this.isEdit) {
        return false
      }
      if (this.job.multiplePickups) {
        for (const item of this.trucking) {
          if (item.relatedDischargingTrucking) {
            return true
          }
        }
        return false
      } else {
        return Boolean(this.truckingInfo.relatedDischargingTrucking)
      }
    },
    localCurrency() {
      return RateUtil.localCurrencyByOffice()
    }
  },
  watch: {
  },
  async created() {
    this.cityList = await getLocationList({}).then((res) => {
      return res.data.list || []
    })
  },
  beforeMount() {
    const context = this
    this.documentManage.set('uploadFileClickHandler', function(value) {
      context.uploadFileClickHandler(value)
    })
    this.documentManage.set('auditUrlClickHandler', function(value) {
      context.auditUrlClickHandler(value)
    })
    this.documentManage.set('showErrorLogClickHandler', function(value) {
      context.showErrorLogClickHandler(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    resetColumnState() {
      for (const item of this.columnDefs) {
        if (item.custom instanceof Object) {
          item.custom.isEdit = !this.readonly
        }
      }
    },
    async onShow(row, isRefresh) {
      this.job = row
      this.loadSites()
      if (!isRefresh) {
        return
      }
      // 初始化
      this.truckingInfo = new Trucking().fillDefaultValue().getData()
      this.truckingInfo.dischargingPortService = true

      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.currentUser = cache.user
      await this.autoCalculateDateRule()
      // 加载数据
      await this.startLoad(row)
      this.multiPickupsEnabled()
      // 加载数据又一次 调用
      await this.checkDefaultTrucking()

      this.btnEnable.grpTruckOrderBtns = this.readonly && (this.job.trucking && this.job.trucking.length > 0 && this.truckingInfo.uuid)
    },
    onLoadingPortServiceChange() {
      this.truckingInfo.dischargingPortService = !this.truckingInfo.loadingPortService
    },
    onDischargingPortServiceChange() {
      this.truckingInfo.loadingPortService = !this.truckingInfo.dischargingPortService
    },
    async startLoad(row) {
      if (this.job == null) {
        return
      }
      this.showDgUsageByG7()
      // 加载数据
      let job = null
      if (row.lob === 'SI') {
        job = new SeaImportJob(row)
      } else {
        job = new Job(row)
      }
      await Promise.all([
        job.getTrucking(),
        job.getCharges()
      ])
      this.job = row
      this.trucking = job.trucking
      if (this.trucking && this.trucking.length > 0) {
        this.$nextTick(async() => {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.topgridApi)
          this.setGridSelect()
          this.selectionChangeHandler({ data: this.truckingInfo })
        })
      }
    },
    syncToDischargingTruckingInfo() {
      const truckingInfoKeys = []
      if (this.job.multiplePickups) {
        for (const item of this.trucking) {
          if (item.relatedDischargingTrucking) {
            truckingInfoKeys.push(item.uuid)
          }
        }
      } else {
        if (this.truckingInfo.relatedDischargingTrucking) {
          truckingInfoKeys.push(this.truckingInfo.uuid)
        }
      }
      const loading = getLoading4Cxt(this)
      syncTruckingToDischargingTruckingInfo(truckingInfoKeys).then(res => {
        this.$message.success(this.$t('Message.SynchronizationSucceeded'))
      }).finally(() => {
        loading.close()
      })
    },
    onCellFocused(event) {
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.topgridApi)
        if (this.topgridApi && event.column) {
          this.topgridApi.forEachNode(node => {
            if (node.rowIndex === event.rowIndex) {
              node.setSelected(true)
              this.truckingInfo = node.data
            }
          })
        }
      })
    },
    // 设置 选中行(加载数据后默认选中第一行记录)
    setGridSelect(selectLastRow = false) {
      const nodes = this.topgridApi.getRenderedNodes()

      // 如无行记录数据，选中值重新设置
      if (nodes.length === 0) {
        this.truckingInfo = new Trucking().fillDefaultValue().getData()
        this.truckingInfo.dischargingPortService = true
      }

      // 选中最后一行记录(用于 行复制 新增，删除)
      if (selectLastRow) {
        let index = 0
        for (const item of nodes) {
          if (index === nodes.length - 1) {
            // item.setSelected(true)
            this.topgridApi.setFocusedCell(index, 'carryingCmp')
            this.truckingInfo = item.data
          }
          index++
        }
      } else {
        // 默认选中第一个
        for (const item of nodes) {
          // item.setSelected(true)
          this.topgridApi.setFocusedCell(0, 'carryingCmp')
          this.truckingInfo = item.data
          break
        }
      }
    },
    // 门店地址
    async loadSites() {
      // 同步实现 loadSiteResultHandler
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      if (!companyCache) return
      const companyUuid = companyCache.uuid
      if (!companyUuid) return
      await getSites(companyUuid).then(res => {
        this.doorList = res.data
      })
    },
    showDgUsageByG7() {
      if (parseInt(cache.config.get('showDgUsageByG7')) === 1) {
        this.gridVisible.dgUsage = false
        this.gridVisible.dgUsageG7 = true
      } else {
        this.gridVisible.dgUsage = true
        this.gridVisible.dgUsageG7 = false
      }
    },
    checkDefaultTrucking() {
      if (!this.job) return
      if (this.isEdit) {
        if (this.trucking === null || this.trucking.length === 0) {
          this.truckingInfo = new Trucking().fillDefaultValue().getData()
          this.truckingInfo.dischargingPortService = true
          this.truckingInfo.jobUuid = this.job.uuid
          this.truckingInfo.truckOrderNo = JobUtils.createTruckOrderNo(this.job)
          this.trucking.push(this.truckingInfo)
        } else {
          this.truckingInfo = this.job.trucking[0]
          if (StrUtils.isEmpty(this.truckingInfo.truckOrderNo)) {
            this.truckingInfo.truckOrderNo = JobUtils.createTruckOrderNo(this.job)
          }
        }
      }
      this.selectionChangeHandler({ data: this.truckingInfo })
    },
    async autoCalculateDateRule() {
      await DateAutoInitRuleManage.getInstance().autoCalculateDateRule(this.job, this.truckingInfo, 'SE')
    },
    multiPickupsEnabled() {
      if (this.isEdit && this.job && !StrUtils.isEmpty(this.job.uuid)) {
        this.multiPickups = true
      } else {
        this.multiPickups = false
      }
    },
    selectionChangeHandler(event) {
      if (!event.data) {
        return
      }
      this.truckingInfo = event.data
      this.neednotReloadTelephone = true
      this.txtEditEable = this.isEdit && (this.truckingInfo.sendState === 0)
      /* if (!isAllowGridClick && event) {
            dgTrucking.selectedItem = truckingInfo;
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          isAllowGridClick = false;
          if (truckingInfo && truckingInfo != dgTrucking.selectedItem && isEditing) {
            fillModel(false);
          }
          if (isEditing && truckingInfo && truckingInfo != dgTrucking.selectedItem && !validate()) {
            dgTrucking.selectedItem = truckingInfo;
            return;
          }
          truckingInfo = dgTrucking.selectedItem as TruckingInfo;*/
      this.checkBtnsState()
      this.fillView()
      this.filterSONo()
      this.loadTruckingInfoUsage(this.truckingInfo)
      this.resetColumnState()
    },
    fillView() {
      if (this.truckingInfo === null) {
        return
      }
      /* if (this.truckingInfo.loadingDate) {
        const date = new Date(this.truckingInfo.loadingDate)
        this.truckingInfo.loadingDateHour = date.getHours()
        this.truckingInfo.loadingDateMinutes = date.getMinutes()
      }*/
      // 控制派车单按钮
      if (!this.truckingInfo.uuid) {
        this.btnEnable.grpTruckOrderBtn = false
      } else {
        this.btnEnable.grpTruckOrderBtns = this.readonly && (this.job.trucking && this.job.trucking.length > 0)
      }
      this.carringCapChange()
    },
    // change carrying company
    async carringCapChange() {
      // 同步实现 carryingContactResultHandler
      if (!this.truckingInfo || this.truckingInfo.carryingCmp <= 0) return
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.truckingInfo.carryingCmp))
      if (!companyCache) {
        this.truckingInfo.carryingCmp = 0
        this.isNullData()
        return
      }
      const company = new Company({ cmpIdx: this.truckingInfo.carryingCmp })
      if (company === null) return
      this.carryingContacts = await company.getContactsBycmpIdx()
      if (this.carryingContacts != null && this.carryingContacts.length > 0) {
        if (this.truckingInfo.driver && this.truckingInfo.driver !== '') {
          // cargo 逻辑实现控件绑定 vue 不需要
        } else {
          this.truckingInfo.driver = this.carryingContacts[0].contactPerson
        }
      } else {
        this.isNullData()
      }
      this.carryingContactsChangeHandler(this.truckingInfo.driver)
    },
    isNullData() {
      this.carryingContacts = []
      this.truckingInfo.driver = ''
      this.truckingInfo.driverTel = ''
    },
    carryingContactsChangeHandler(value) {
      if (this.truckingInfo == null) return
      this.neednotReloadTelephone = false
      this.needReloadDriver = false

      const contact = this.carryingContacts.find(item => item.contactPerson === value)

      // if (carryingContacts.selectedItem is Contact) {
      if (this.carryingContacts != null) {
        if (contact != null) {
          if (!this.neednotReloadTelephone) {
            this.truckingInfo.driverTel = contact.telephone
          }
        }
      } else {
        // todo
        // CARGO-6834，互联派车返回司机，没有在cargoware维护的
        /* if (carryingContacts.selectedItem is String) {
              if (!StrUtils.isEmpty(carryingContacts.selectedItem)) {
                return
              }
            }*/
        //
        const contacts = this.carryingContacts
        if (contacts != null && contacts.length > 0 && this.needReloadDriver) {
          var cat = contacts[0]
          this.truckingInfo.driver = cat.contactPerson
          this.truckingInfo.driverTel = cat.telephone
        } else {
          this.truckingInfo.driver = ''
          if (this.needReloadDriver) {
            this.truckingInfo.driverTel = ''
          }
        }
      }

      this.topgridApi.refreshCells({ force: true })
    },
    driverInfomationsChangeHandler() {
      if (!this.truckingInfo || !this.truckingInfo.driverName) return
      if (this.driverInfomations && this.driverInfomations.length > 0) {
        for (const item of this.driverInfomations) {
          if (item && item.driverName && item.driverName === this.truckingInfo.driverName) {
            this.truckingInfo.driverPhone = item.driverPhone
            this.truckingInfo.plateNumber = item.plateNumber
            this.truckingInfo.driverIdCard = item.driverIdCard
          }
        }
      }
    },
    setSelectDoor() {
      // 选中 门点，vue 双向绑定 不需要实现
    },
    checkBtnsState() {
      this.btnEnable.btDel = this.isEdit && this.truckingInfo != null
    },
    // 过滤S/O No
    filterSONo() {
      this.soNo = ''
      if (this.job.lob === 'SE') {
        if (this.isEdit) {
          const soNos = this.job.soNo == null ? [] : this.job.soNo.split('\n')
          const len = soNos.length
          for (let i = len - 1; i >= 0; i--) {
            const s = soNos[i]
            for (const truck of this.job.trucking) {
              if (truck === this.truckingInfo) {
                continue
              }
              let isIn = false
              if (truck.soNo && truck.soNo.length > 0) {
                const ts = truck.soNo.split('\n')
                for (const t of ts) {
                  if (t === s) {
                    isIn = true
                    soNos.splice(i, 1)
                    break
                  }
                }
              }
              if (isIn) {
                break
              }
            }
          }
          this.soNo = soNos.join('\n')
        } else if (this.truckingInfo) {
          this.soNo = this.truckingInfo.soNo
        }
      }
    },
    async loadTruckingInfoUsage(truckingInfo) {
      if (!truckingInfo.uuid) {
        return
      }
      await queryByTruckingInfo({ truckingInfoUuid: truckingInfo.uuid }).then(res => {
        this.usages = res.data
        this.loadContainerUsageResultHandler()
      })
    },
    loadContainerUsageResultHandler() {
      this.isAllowGridClick = true
      // 由于延迟加载，isTMSChanged() 会滞后
      this.txtTMSHint = ''
      if (this.usages != null) {
        for (const containerUsage of this.usages) {
          // type=2
          if (containerUsage.type >= 2) {
            this.txtTMSHint = this.$t('Message.ThisCarOrderIsChanged')
            return
          }
        }
      }
    },
    // 表单验证
    validate(isLastCheck = false) {
      if ((this.truckingInfo.carryingCmp === 0 || this.truckingInfo.carryingCmp === '') && (!isNaN(this.truckingInfo.truckingFee) && this.truckingInfo.truckingFee !== 0)) {
        throw new TabError(this.$t('Message.PleaseEnterTheShippingCompanyInformation'), 'tabLocalService')
      }
      if (isLastCheck && this.trucking) {
        const truckingMap = {}
        for (const trucking of this.trucking) {
          if (StrUtils.isEmpty(trucking.truckOrderNo)) {
            continue
          }
          if (truckingMap.hasOwnProperty(trucking.truckOrderNo)) {
            throw new TabError(this.$t('Message.SameJobtruckOrderNo'), 'tabLocalService')
          } else {
            truckingMap[trucking.truckOrderNo] = true
          }
        }
      }
      return true
    },
    // 复制新增
    copyNewHandler() {
      if (this.truckingInfo === null) {
        this.$message.warning('请选择指定数据')
        return
      }
      if (this.truckingInfo && this.isEdit) {
        this.fillModel(false)
      }
      const item = this.truckingInfo
      if (this.validate()) {
        const trucking = new Trucking().fillDefaultValue().getData()
        trucking.jobUuid = this.job.uuid
        this.copyBasic(trucking, item)
        trucking.loadingDate = item.loadingDate
        //	trucking.soNo = item.soNo;
        trucking.cubage = item.cubage
        trucking.plateNumber = item.plateNumber
        trucking.driverName = item.driverName
        trucking.driverPhone = item.driverPhone
        trucking.driverIdCard = item.driverIdCard
        trucking.loadingPortService = item.loadingPortService
        trucking.dischargingPortService = item.dischargingPortService
        trucking.dischargingWay = item.dischargingWay
        trucking.po = item.po
        trucking.zipCode = item.zipCode
        this.trucking.push(trucking)
        trucking.truckOrderNo = JobUtils.createTruckOrderNo(this.job)
        // 复制新增时 派车单号 和拖车费不复制
        trucking.truckingFee = 0
        this.$nextTick(async() => {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.topgridApi)
          this.setGridSelect(true)
          this.selectionChangeHandler({ data: trucking })
        })
      }
    },
    // 新增
    addHandler() {
      if (this.truckingInfo && this.isEdit) {
        this.fillModel(false)
      }
      if (this.validate()) {
        const trucking = new Trucking().fillDefaultValue().getData()
        trucking.dischargingPortService = true
        trucking.jobUuid = this.job.uuid
        // 新增的时候门点也清空
        trucking.doorName = ''
        trucking.doorMan = ''
        trucking.doorManTel = ''
        trucking.doorAddr = ''
        this.trucking.push(trucking)
        trucking.truckOrderNo = JobUtils.createTruckOrderNo(this.job)
        this.$nextTick(async() => {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.topgridApi)
          this.setGridSelect(true)
          this.selectionChangeHandler({ data: trucking })
        })
      }
    },
    // 删除
    delHandler() {
      // 去掉装箱信息和门点的关联（移至后端处理）
      for (const usage of this.job.containerUsages) {
        if (usage.truckingInfoUuid === this.truckingInfo.uuid) {
          usage.truckingInfoUuid = null
        }
      }
      this.truckingInfo.jobUuid = null
      if (this.job.trucking.length > 0) {
        this.job.carryingCmp = this.trucking[0].carryingCmp
      } else {
        this.job.carryingCmp = 0
      }
      // 移除
      const index = this.trucking.indexOf(this.truckingInfo)
      if (this.truckingInfo.uuid) {
        this.delTruckingInfoUuids.push(this.truckingInfo.uuid)
      }
      this.trucking.splice(index, 1)
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.topgridApi)
        this.setGridSelect(false)
        this.selectionChangeHandler({ data: this.truckingInfo })
      })
    },
    // 拖车费
    truckingFeeCharge() {
      if (this.truckingInfo && this.isEdit) {
        this.createCharge(true, 'truckingFee')
      }
    },
    doorsChangeHandler(value, option) {
      this.truckingInfo.doorMan = ''
      this.truckingInfo.doorManTel = ''
      this.truckingInfo.doorAddr = ''
      this.truckingInfo.zipCode = ''
      if (option) {
        this.truckingInfo.doorMan = option.contact
        this.truckingInfo.doorManTel = option.phone
        this.truckingInfo.doorAddr = option.address
        this.truckingInfo.zipCode = option.zipCode
        if (option.remarks) this.truckingInfo.remarks = option.remarks
      }
      // gird 刷新
      this.$nextTick(() => {
        this.topgridApi.refreshCells({ force: true })
      })
    },
    // 运输公司
    async carryingCmpChangeHandler() {
      if (this.truckingInfo == null) return

      this.neednotReloadTelephone = false
      this.needReloadDriver = true
      this.job.carryingCmp = this.truckingInfo.carryingCmp
      this.truckingInfo.driver = ''
      this.truckingInfo.driverTel = ''
      this.carryingContacts = []
      await this.carringCapChange()
      this.driverInfomations = await JobUtils.getDriverInformationByCarryingCap(this.truckingInfo, this.truckingInfo.carryingCmp)
      // gird 刷新
      this.$nextTick(() => {
        this.topgridApi.refreshCells({ force: true })
      })
      this.truckingFeeCharge()
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      const reqKeys = this.job.requestSelectedKeys // todo 此处 调用不到 组件 selectedSpecialRequest this.getRequestSelectedKeys()
      params.jobuuid = this.job.uuid
      params.JOB_UUID = this.job.uuid
      params.TRUCKING_UUID = StrUtils.isEmpty(this.truckingInfo.uuid) ? null : this.truckingInfo.uuid
      params.USER_ID = this.currentUser.userId
      params.REQUEST_UUID = ((!reqKeys || reqKeys.length === 0) ? '' : reqKeys)
      params.category = 'TRUCKING'
      params.ctx = new SeaImportJob(this.job)
      this.$logger.log('params', params)
      return params
    },
    // 打印回调
    printedCallback(event) {
      this.$logger.log(event)
      const template = event.template
      const documentType = event.documentType
      if (template && documentType) {
        const objParams = { jobUuid: this.job.uuid, docKeys: documentType.uuid }
        this.$logger.log(objParams)
        updateTrackingForDocumentType(objParams)
      }
    },
    getSubmitData() {
      this.validateForm()
      this.fillModel(false)
      const job = { ...this.job }
      // 第一次创建（只有一条记录）
      if (this.trucking.length === 0 && this.truckingInfo && this.truckingInfo.jobUuid === this.job.uuid) {
        this.trucking.push(this.truckingInfo)
      }
      return {
        job,
        charges: this.job.charges.filter(p => p.isDirty === true), // todo 在 费用tab 未打开的情况下 需要保持charges
        truckingInfo: this.trucking,
        delTruckingInfoUuids: this.delTruckingInfoUuids
      }
    },
    validateForm() {
      this.validate(true)
    },
    fillModel(isFinal = false) {
      // 判断门点 手工输入非 选择
      const door = this.doorList.find(item => item.name === this.truckingInfo.doorName)
      if (!door) { // new door
        this.needSaveCustomer = true
        this.newDoor()
      }
      // 日期组装
      /* if (this.truckingInfo.loadingDate) {
        this.truckingInfo.loadingDate = this.truckingInfo.loadingDate.substr(0, 10) + ' ' + this.truckingInfo.loadingDateHour + ':' + this.truckingInfo.loadingDateMinutes
        this.truckingInfo.loadingDate = ColumnUtils.formateDateToString(this.truckingInfo.loadingDate, 'yyyy-MM-dd hh:mm:ss')
      }*/
      // eslint-disable-next-line no-empty
      if (this.job.multiplePickups) {
      } else {
        this.truckingInfo.soNo = ''
      }
      this.createCharge(isFinal)
    },
    newDoor() {
      if (!this.job.customerId || this.job.customerId === 0) {
        return
      }
      if (!this.truckingInfo.doorName) {
        return
      }
      // 填写内容是下拉框中的数据源
      const inputDoor = this.doorList.find(p => p.name === this.truckingInfo.doorName)
      if (inputDoor) {
        return
      }

      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      const door = {
        name: this.truckingInfo.doorName,
        contact: this.truckingInfo.doorMan,
        phone: this.truckingInfo.doorManTel,
        address: this.truckingInfo.doorAddr,
        companyUuid: companyCache.uuid
      }
      addSites(door)
    },
    async createCharge(isFinal, source) {
      if (!this.truckingInfo.truckingFee) {
        this.$nextTick(() => {
          this.truckingInfo.truckingFee = 0
        })
      }
      if (!isFinal) {
        return
      }
      const chargeCount = this.getCost()
      const amount = this.truckingInfo.truckingFee
      const truckingCount = this.job.trucking ? this.job.trucking.length : 0
      let charge = null
      let isCreate = true
      if (this.job.charges && this.job.charges.length > 0) {
        for (const c of this.job.charges) {
          if (c.truckOrderNo === this.truckingInfo.truckOrderNo) {
            isCreate = false
            charge = c // 先录费用后录拖车使用
            break
          }
        }
      }
      const shared = charge && (charge.shared || (charge.shareScheme && parseInt(charge.shareScheme) !== 0)) // 是否已分摊
      if (source === 'truckingFee' &&
          charge &&
          charge.verifiedAmount === 0 &&
          StrUtils.isEmpty(charge.billingUuid) &&
          StrUtils.isEmpty(charge.billingPaymentUuid) &&
          StrUtils.isEmpty(charge.invoiceUuid) &&
          charge.uuid &&
          !(charge.chargeState === 0 && !charge.confirmState && !this.job.payableChargeLockedStatus && !shared)
      ) {
        await this.truckingFeeConfirm(source)
        return
      }
      const chargeItemId = parseInt(cache.config.get('TruckingFeeCode')) // TRUCKING_FEE_CODE;
      const chargeItem = ChargeItem.getChargeItemById(chargeItemId)
      if (chargeItem && chargeItem.active && isCreate && truckingCount > chargeCount && amount > 0) {
        charge = this.createNewCharge()
        charge.isDirty = true
        charge.chargeItemId = chargeItemId
        if (chargeItem.taxRate > 0) {
          charge.taxRate = chargeItem.taxRate
        }
        if (chargeItem.measure !== null && chargeItem.measure !== '') {
          charge.measure = chargeItem.measure
        }
        charge.unitPriceIncludeTax = parseInt(cache.config.get('InputIncludingTaxUnitPrice')) === 2
        charge.truckOrderNo = this.truckingInfo.truckOrderNo
        // 其他tab 有charge 提交 需合并或其他方案待处理
        if (!this.job.charges) {
          this.job.charges = []
        }
        charge.serialNumber = this.job.charges.filter(p => !p.receivable).length + 1
        charge.isDirty = true
        this.job.charges.push(charge)
      }
      if (charge && charge.verifiedAmount === 0 && StrUtils.isEmpty(charge.billingUuid) && StrUtils.isEmpty(charge.billingPaymentUuid) && StrUtils.isEmpty(charge.invoiceUuid)) {
        if (!isNaN(amount) && amount > 0) {
          charge.accountId = this.truckingInfo.carryingCmp
          const accountIds = [{
            accountId: charge.accountId
          }]
          await this.initSettlementAgentsMap(accountIds)
          await this.getSettlementByCompanyId(charge)
          charge.changer = this.$store.getters.userId
          if (charge.uuid) {
            if (charge.chargeState === 0 && !charge.confirmState && !this.job.payableChargeLockedStatus && !shared) {
              charge.unitRate = amount
            }
          } else {
            charge.unitRate = amount
          }
          if (charge.unitPriceIncludeTax) {
            ChargeUtils.calculateTaxAmount(charge, parseFloat((charge.unitRate * charge.quantity).toFixed(2)), charge.taxRate)
          } else {
            ChargeUtils.calculateTax(charge, parseFloat((charge.unitRate * charge.quantity).toFixed(2)), charge.taxRate, true)
          }
          charge.isDirty = true
        } else {
          if (!shared && !(await this.truckingFeeConfirm(source))) {
            return
          }
        }
      }
      // 设置开票抬头
      if (charge && charge.accountId && charge.accountId > 0) {
        ChargeUtils.updateDefaultInvoiceTitle([charge])
      }
      /* if (needSaveCustomer) {
          var customer:Company = Company.getCompanyById(job.customerId);
          if (customer)
            customer.save2(saveCustomerResult, saveCustomerFault);
        }*/
      this.context.reloadCharge = true
    },
    // 初始化结算代理s
    async initSettlementAgentsMap(charges) {
      // 获取唯一的 accountId 列表
      const accountIds = Array.from(new Set(charges.map(p => p.accountId)))

      // 如果没有需要处理的 accountId，直接返回
      if (!accountIds || accountIds.length <= 0) return

      // 从接口获取结算代理数据
      const settlementAgentMap = await getSettlementAgentsByCmpIdxList(accountIds).then((res) => res.data)

      // 如果接口返回的数据为空，直接返回
      if (!settlementAgentMap) return

      // 将接口返回的数据转换为 Map 并放入 customerSettlementAgentMap 中
      Object.entries(settlementAgentMap).forEach(([accountId, agentData]) => {
        this.currentViewCacheData.customerSettlementAgentMap.set(Number(accountId), agentData)
      })
    },
    // 根据结算对象，获取结算代理
    async getSettlementByCompanyId(charge) {
      const accountId = charge.accountId
      if (!accountId || accountId <= 0) return
      const chargeAccount = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId)
      if (!chargeAccount) {
        return
      }
      if (this.currentViewCacheData.customerSettlementAgentMap.has(accountId)) {
        const staticOptions = this.currentViewCacheData.customerSettlementAgentMap.get(accountId)
        const index = staticOptions.findIndex(p => p.uuid === chargeAccount.uuid)
        if (index < 0) {
          if (chargeAccount) {
            staticOptions.push(chargeAccount)
          }
          this.currentViewCacheData.customerSettlementAgentMap.set(accountId, staticOptions)
        }
        charge.settlementAgentId = staticOptions[0].cmpIdx
      } else {
        const res = await getSettlementAgentsByCmpIdx(charge.accountId)
        let dbSettlementAgents = res.data
        if (!dbSettlementAgents) dbSettlementAgents = []
        if (chargeAccount) {
          const index = dbSettlementAgents.findIndex(p => p.uuid === chargeAccount.uuid)
          if (index < 0) {
            dbSettlementAgents.push(chargeAccount)
          }
        }
        charge.settlementAgentId = dbSettlementAgents[0].cmpIdx
        this.currentViewCacheData.customerSettlementAgentMap.set(accountId, dbSettlementAgents)
      }
    },
    createNewCharge() {
      const charge = new Charge().fillDefaultValue().getData()
      charge.jobUuid = this.job.uuid
      charge.businessDate = this.job.businessDate
      charge.quantity = 1
      charge.localCurrency = this.localCurrency
      charge.currency = this.localCurrency
      charge.exchangeRate = 1
      charge.measure = 'NML'
      charge.receivable = false
      charge.oversea = false
      charge.verifiedAmount = 0
      charge.inputDate = new Date()
      charge.inputBy = this.currentUser.userId
      charge.branchId = this.$store.getters.currentOfficeId

      charge.inputByDep = this.job.opDepartment
      charge.businessDate = this.job.businessDate

      // 此处增加标识，费用页签再保存会导致费用重复生成
      charge.createdByOther = true
      return charge
    },
    // get job's trucking charge
    getCost() {
      // TRUCKING_FEE_CODE  默认拖车费
      const chargeCode = parseInt(cache.config.get('TruckingFeeCode'))
      let count = 0
      for (const charge of this.job.charges) {
        if (charge.chargeItemId === chargeCode && !charge.isReceivable) {
          count++
        }
      }
      return count
    },
    async truckingFeeConfirm(source) {
      if (this.job.lob === 'SI' && source === 'truckingFee') {
        const flag = await this.$confirm(this.$t('SeaExport.IfToTheCurrentIt'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('constant.yes'),
          cancelButtonText: this.$t('constant.no'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          this.truckingInfo.truckingFee = this.oldTruckintFee
          return false
        }
      }
      return true
    },
    /**
       * 复制属性
       */
    copyBasic(target, source) {
      target.carryingCmp = source.carryingCmp
      target.doorAddr = source.doorAddr
      target.doorMan = source.doorMan
      target.doorManTel = source.doorManTel
      target.doorName = source.doorName
      target.cubage = source.cubage
      target.quantity = source.quantity
      target.weight = source.weight
      target.remarks = source.remarks
      // fix Bug 1750
      //			loadingDate = source.loadingDate;
      target.driver = source.driver
      target.driverTel = source.driverTel
    },
    // 除了第一个记录外 其他记录删除
    multiPickupsChangeHandler() {
      if (!this.job.multiplePickups && this.trucking && this.trucking.length > 1) {
        const len = this.trucking.length
        for (let i = len - 1; i >= 1; i--) {
          // 移除
          const index = this.trucking.indexOf(this.trucking[i])
          if (this.trucking[i].uuid) {
            this.delTruckingInfoUuids.push(this.trucking[i].uuid)
          }
          this.trucking.splice(index, 1)
        }
      }
      if (this.truckingInfo) {
        this.fillModel()
      }
      this.checkDefaultTrucking()
    },
    refreshGrid() {
      // gird 刷新
      this.$nextTick(() => {
        this.topgridApi.refreshCells({ force: true })
      })
    },
    linkUsageClickHandler() {
      for (const item of this.usages) {
        if (!StrUtils.isEmpty(item.code)) {
          this.$message.warning(this.$t('Message.ThisCarOrderIsSendedNoAddUsage'))
          return
        }
      }
      this.containerUsageDialog.visible = true
    },
    // 选择装箱信息后的处理
    selectContainerUsageHandler() {
      this.$message.success(this.$t('Message.SaveSuccessfully'))
      // 重新加载 装箱信息列表
      if (!this.isEdit && this.job && this.job.containerUsages) {
        this.job.containerUsages = ''
        this.job.containers = ''
        new Job(this.job).loadJobRelated({ containerUsages: true, containers: true })
      }
      // 重新加载 装箱信息列表
      this.loadTruckingInfoUsage(this.truckingInfo)
    },
    // 移除装箱信息
    delLinkUsageClickHandler() {
      const selections = this.gridApi.getSelectedRows()
      if (selections.length === 0) {
        return
      }
      this.$confirm(this.$t('Message.SureYouRemoveThisNData1') + ' ' + selections.length + ' ' + this.$t('Message.SureYouRemoveThisNData2'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        let n = true
        for (const usage of selections) {
          if (!(usage.truckStatus === '' || usage.truckStatus == null || usage.truckStatus === '03' ||
              usage.truckStatus === '05' || usage.truckStatus === '11' || usage.truckStatus === '00')) {
            this.$message.warning(this.$t('Message.ThisBoxIsNotAllowedToBeDeleted'))
            n = false
            return
          }
        }
        if (n) {
          const containerUsagesIds = Array.from(selections, p => p.uuid).reduce((a, b) => a + ',' + b)
          delContaierUsageLinkedTruckingInfo({ containerUsagesIds: containerUsagesIds }).then(res => {
            this.$message.success(this.$t('Message.DeleteSuccessfully'))
            if (!this.isEdit && this.job && this.job.containerUsages) {
              this.job.containerUsages = ''
              this.job.containers = ''
              new Job(this.job).loadJobRelated({ containerUsages: true, containers: true })
            }
            // 重新加载 装箱信息列表
            this.containerUsages = []
            this.loadTruckingInfoUsage(this.truckingInfo)
          })
        }
      })
    },
    // 互联派车按钮组
    btnConnectedTruckClickHandler() {
      if (this.command1 === this.$t('SeaExport.DispatchTuckOrder')) {
        this.dispatchTruckOrderClickHandler()
      } else if (this.command1 === this.$t('SeaExport.ModifyTuckOrder')) {
        this.modifyTuckOrderClickHandler()
      } else if (this.command1 === this.$t('SeaExport.RevokeTuckOrder')) {
        // 撤单
        this.revokeTuckOrderClickHandler()
      } else if (this.command1 === this.$t('SeaExport.SearchTuckOrder')) {
        // 查询派车单
        this.getTruckOrderClickHandler()
      }
      // cargo 此按钮未开放 前端 注释了<!--<fx:Object label="上传附件"/>-->
      /* else if (this.command1 === this.$t('SeaExport.DispatchTuckOrder')) {
          uploadFile();
        }*/
    },
    // 发送派车单接口
    dispatchTruckOrderClickHandler() {
      console.log('dispatchTruckOrderClickHandler')
      if (this.truckingInfo == null || StrUtils.isEmpty(this.truckingInfo.uuid) || this.truckingInfo.carryingCmp === 0) {
        this.$message.warning(this.$t('Message.PleaseEnterFleetInformatio'))
        return
      }
      if (this.usages == null || this.usages.length === 0) {
        this.$message.warning(this.$t('Message.NoAssociatedContainerInfo'))
        return
      }
      // CARGO-6783，派单成功后，在当票继续作其他信息修改后，在保存，会冲掉派单标记
      for (const containerUsage of this.usages) {
        // if (!StrUtils.isEmpty(containerUsage.code)) {
        if (!StrUtils.isEmpty(containerUsage.truckStatus) && containerUsage.truckStatus !== SeaExportConstants.TRUCKING_UN_DISPATCHED.code) {
          this.$message.warning(this.$t('Message.ThisCarOrderIsSended'))
          return
        }
      }
      // 派单成功之后，不可以再次派单，只能通过改单进行修改请求。
      //				if (truckingInfo != null && truckingInfo.sendState >= 1)
      //				{
      //					MessageDialog.warning(resourceManager.getString('Message','ThisCarOrderIsSended'),resourceManager.getString('Message','Warning'));
      //					return;
      //				}

      this.$confirm(this.$t('Message.AreYouSureYouWantToSendACarOrder'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        // 派车类型默认值: 1=互联派车  2=鸭嘴兽
        const value = String(cache.config.get('DispatchTruckTypeDefaultValue'))
        if (value === '2') {
          sendTruckOrder2Duck(this.truckingInfo).then(res => {
            this.sendTruckingInfoHandler(res.data)
          }).finally(() => { this.loading.close() })
        } else {
          sendTruckOrder(this.truckingInfo).then(res => {
            this.sendTruckingInfoHandler(res.data)
          }).finally(() => { this.loading.close() })
        }
      }
      )
    },
    sendTruckingInfoHandler(result) {
      const msg = result
      if (msg) {
        if (msg.indexOf('1') >= 0) {
          this.$message.success(this.$t('Message.DispatchSuccess'))
          this.loadTruckingInfoUsage(this.truckingInfo)
        } else {
          this.$message.info(msg)
        }
      } else {
        this.$message.error(this.$t('Message.DispatchFailed'))
      }
    },
    // 更改派车单
    modifyTuckOrderClickHandler() {
      const selModifiedContainerUsage = this.getSelectedModifiedTruckData()
      if (selModifiedContainerUsage) {
        // 派单成功之后，不可以再次派单，只能通过改单进行修改请求。
        // if (truckingInfo != null && truckingInfo.sendState == 0)
        // CARGO-6783，派单成功后，在当票继续作其他信息修改后，在保存，会冲掉派单标记
        // if (StrUtils.isEmpty(selModifiedContainerUsage.code))
        if (StrUtils.isEmpty(selModifiedContainerUsage.truckStatus) || selModifiedContainerUsage.truckStatus === SeaExportConstants.TRUCKING_UN_DISPATCHED.code) {
          this.$message.warning(this.$t('Message.ThisCarOrderCanOnlyBeModifiedAfterSending'))
          return
        }

        this.$confirm(this.$t('Message.AreYouSureYouWantToModifyACarOrder'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          const value = String(cache.config.get('DispatchTruckTypeDefaultValue'))
          if (value === '2') {
            return
          } else {
            this.loading = getLoading()
            sendModifiedTruckOrder({ truckingInfo: this.truckingInfo, containerUsage: selModifiedContainerUsage }).then(res => { this.sendModifiedTruckingInfoHandler(res.data) }).finally(() => { this.loading.close() })
          }
        })
      }
    },
    sendModifiedTruckingInfoHandler(result) {
      var msg = result
      if (msg) {
        if (msg.indexOf('1') >= 0) {
          this.$message.success(this.$t('Message.ModifiedTruckOrderSuccess'))
          this.loadTruckingInfoUsage(this.truckingInfo)
        } else {
          this.$message.info(msg)
        }
      } else {
        this.$message.error(this.$t('Message.ModefiedTruckOrderFaild'))
      }
    },
    // 撤单
    revokeTuckOrderClickHandler() {
      const selModifiedContainerUsage = this.getSelectedModifiedTruckData()
      if (selModifiedContainerUsage) {
        // CARGO-6454，客户撤单条件：此订单是未接单状态
        if (!StrUtils.isEmpty(selModifiedContainerUsage.truckStatus) && selModifiedContainerUsage.truckStatus !== SeaExportConstants.TRUCKING_UN_APPROVED.code) {
          this.$message.warning(this.$t('Message.ThisCarOrderCanOnlyBeRevokedIsUnApproved'))
          return
        }

        this.$confirm(this.$t('Message.AreYouSureYouWantToRevokeACarOrder'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          const value = String(cache.config.get('DispatchTruckTypeDefaultValue'))
          if (value === '2') {
            return
          } else {
            this.loading = getLoading()
            revokeTruckOrder({ truckingInfo: this.truckingInfo, containerUsage: selModifiedContainerUsage }).then(res => {
              this.sendRevokeTruckingInfoHandler(res.data)
            }).finally(() => { this.loading.close() })
          }
        })
      }
    },
    sendRevokeTruckingInfoHandler(result) {
      const msg = result
      if (msg) {
        if (msg.indexOf('1') >= 0) {
          this.$message.success(this.$t('Message.RevokeTruckOrderSuccess'))
          this.loadTruckingInfoUsage(this.truckingInfo)
        } else {
          this.$message.info(msg)
        }
      } else {
        this.$message.error(this.$t('Message.RevokeTruckOrderFaild'))
      }
    },
    // 查询派车单
    getTruckOrderClickHandler() {
      const selModifiedContainerUsage = this.getSelectedModifiedTruckData()

      if (selModifiedContainerUsage) {
        // 派车类型默认值: 1=互联派车  2=鸭嘴兽
        const value = String(cache.config.get('DispatchTruckTypeDefaultValue'))
        if (value === '2') {
          return
        } else {
          const params = {}
          params.truckingInfo = this.truckingInfo
          params.containerUsage = selModifiedContainerUsage
          this.loading = getLoading()
          getTruckOrder(params).then(res => {
            this.getTruckingInfoHandler(res.data)
          }).finally(() => { this.loading.close() })
        }
      }
    },
    getTruckingInfoHandler(msg) {
      if (msg) {
        if (msg.indexOf('1') >= 0) {
          this.$message.success(msg.replace('1', ''))
          this.loadTruckingInfoUsage(this.truckingInfo)
        } else {
          const oldName = this.$t('queryJob.EstimatedLoadingDate')
          const newName = this.$t('SeaExport.CargosExpectedArrivalDatePacking')
          msg = msg.replace(oldName, newName)
          this.$message.info(msg)
        }
      } else {
        this.$message.error(this.$t('Message.SendFailed'))
      }
    },
    getSelectedModifiedTruckData() {
      let modifiedUsage = null
      if (this.usages === null || this.usages.length === 0) {
        this.$message.warning(this.$t('Message.NoAssociatedContainerInfo'))
        return
      }
      const selUsages = this.gridApi.getSelectedRows()
      if (selUsages.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
      } else if (selUsages.length > 1) {
        this.$message.warning(this.$t('Message.OnlySelectOneData'))
      } else {
        modifiedUsage = selUsages[0]
      }
      return modifiedUsage
    },
    // 派车单日志
    showTuckOrderLogClickHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        return
      }
      queryTuckOrderLog({ containerUsageUuid: rows[0].uuid }).then(res => { this.queryTuckOrderLogResultHandler(res.data) })
    },
    queryTuckOrderLogResultHandler(data) {
      this.truckOrderLogDialog.rowData = data
      this.truckOrderLogDialog.visible = true
    },
    // 上传附件
    uploadFileClickHandler(value) {
      // CARGO-6902，编辑状态下，箱记录的附件上传会异常，导致刚录入的拖车费没了
      if (this.isEdit) {
        return
      }
      this.uploadCommonFileDialog.model = { uuid: value }
      this.uploadCommonFileDialog.visible = true
    },
    // 费用确认
    auditUrlClickHandler(value) {
      if (value) {
        window.open(value)
      }
    },
    // 拖车费编辑
    onCellChange(params) {
      const item = params.data
      item.truckingFee = ColumnUtils.number2ColumnLabelFunc(NumberUtils.roundHalfUp(item.truckingFee, 2))
      this.gridApi.refreshCells({ force: true })
      // 实现 itemEditEndHandler
      this.truckingFeeCharge()
      this.$nextTick(() => {
        this.truckingFeeSum()

        // 记录装箱明细的 拖车费 用于保存
        // 去重（更新上次的修改）
        const index = this.containerUsages.findIndex(p => p.uuid === item.uuid)
        if (index >= 0) {
          this.containerUsages.splice(index, 1)
        }
        this.containerUsages.push({ uuid: item.uuid, truckingFee: item.truckingFee })
        // 赋值给保存
        this.truckingInfo.containerUsages = this.containerUsages
      })
    },
    truckingFeeSum() {
      let truckingFeeSum = 0
      for (const u of this.usages) {
        if (!isNaN(u.truckingFee)) {
          truckingFeeSum += u.truckingFee
        }
      }
      if (truckingFeeSum > 0) {
        this.truckingInfo.truckingFee = truckingFeeSum
      }
    },
    // 派车单日志
    showErrorLogClickHandler(tosTaskId) {
      if (!StrUtils.isEmpty(tosTaskId)) {
        queryEventLogList({ taskId: tosTaskId }).then(res => { this.queryErrorLogResultHandler(res.data) })
      }
    },
    queryErrorLogResultHandler(data) {
      if (data && data.length > 0) {
        this.errorLogDialog.rowData = data
        this.errorLogDialog.visible = true
      } else {
        this.$message.info('暂无相关信息')
      }
    },
    submitCallBack(notRemindNextTime) {
      this.yazuishouVisible = false
    },
    endTabHandler() {
      this.job.truckingPage = true
    },
    // 新增门点弹框
    addDoor() {
      if (!this.job.customerId || this.job.customerId === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectCommissioningUnit'))
        return
      }
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      if (!companyCache) return
      const companyUuid = companyCache.uuid
      if (!companyUuid) return
      this.addDoorDialog.form = {
        companyUuid: companyUuid,
        companyName: this.$store.getters.language === 'zh' ? companyCache.chineseName : companyCache.englishName
      }
      this.addDoorDialog.visible = true
    }
  }

}
</script>

<style scoped lang="scss">
.form-card-wrapper .form-row ::v-deep {
  .diffTipColumn {
    color: red
  }
}
.inline-form{
  margin-left: 20px;
  label{
    font-weight: normal;
  }
  .el-form-item__content{
    & > label{
      width: 40px;
      display: inline-block;
      &:first-of-type{
        margin-left: 1px;
      }
    }
    .el-input-number{
      width: 86px;
      margin-right: 10px;
    }
  }
  .el-form-item{
    &:nth-of-type(2){
      margin-left: 70px;
    }
    /deep/ .so-no-selector{
      & > span{
        &:first-of-type{
          flex: 1;
        }
      }
    }
  }
}
.trucking-form{
  width: 1200px;
  box-sizing: border-box;
  padding-left: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  .el-form{
    flex: 1;
    .el-form-item__content{
      & > label{
        margin: 0 10px;
        font-weight: normal;
      }
      span{
        &.currency{
          margin-left: 10px;
        }
      }
    }
    .vehicle-btn{
      margin-left: 10px;
    }
    .vehicle-tip{
      margin-left: 5px;
      font-size: 16px;
      color: #1F75D5;
    }
  }
}
.plate_number{
  width: 280px;
  height: 28px;
  box-sizing: border-box;
  padding-left: 10px;
  vertical-align: middle;
  background-color: #f3f4f5;
  border: 1px solid #E4E7ED;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
}
</style>

<!-- 英文样式 -->
<style scoped lang="scss">
#app.en {
  .inline-form .el-form-item__content > label {
    width: 55px
  }
  .inline-form .el-form-item:nth-of-type(2) {
    margin-left: 25px;
}
}
</style>
